import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { AppVersion } from '@zerops/models/app-version';
import { BuildProcessStates } from '../../build-state-steps.model';
import { getPipelineState } from '../../build-state-steps.utils';

@Component({
  selector: 'zui-init-build-step',
  templateUrl: './init-build-step.component.html',
  styleUrls: [ './init-build-step.component.scss' ],
 changeDetection: ChangeDetectionStrategy.OnPush
})
export class InitBuildStepComponent {

  buildProcessStates = BuildProcessStates;

  @Input()
  set appVersion(v: AppVersion) {
    this._appVersion = v;
    this._state = getPipelineState(this._appVersion)?.INIT_BUILD_CONTAINER;
  }
  get appVersion(): AppVersion {
    return this._appVersion;
  }

  @Input()
  hideText = false;

  _state: BuildProcessStates;
  private _appVersion: AppVersion;
}
